var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M29.335 16C29.335 8.64 23.36 2.667 16 2.667 8.641 2.667 2.668 8.64 2.668 16c0 6.453 4.587 11.827 10.667 13.067V20h-2.667v-4h2.667v-3.333A4.672 4.672 0 0 1 18 8h3.334v4h-2.667c-.733 0-1.333.6-1.333 1.333V16h4v4h-4v9.267c6.733-.667 12-6.347 12-13.267Z"}));
}

Facebook.defaultProps = {"width":"32","height":"32","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
